import { render, staticRenderFns } from "./about1.vue?vue&type=template&id=26c177d6&"
import script from "./about1.vue?vue&type=script&lang=js&"
export * from "./about1.vue?vue&type=script&lang=js&"
import style0 from "./about1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports